export enum NavigationCategoryEnum {
  ADMIN = "admin",
  HOME = "home",
  FLEET = "fleet",
  MGMT = "management",
  CRM = "crm",
  SETTINGS = "settings",
  HELP = "help"
}
